export const MODULE_NAME = 'users';
export const ACCESS_NAME = 'Users';
